/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */
    heads_up: 'توجه',
    attention: 'توجه',
    pay: 'پرداخت',
    pay_now: 'پرداخت',
    please_wait: 'لطفاً منتظر بمانید',
    close: 'خروج',
    notice: 'توجه',
    dismiss: 'رد کن',
    accepted_proof: 'مدارک قابل قبول',
    rejected: 'رد شد',
    upload: 'آپلود',
    receipt: 'رسید',
    receipt_unavailable:'رسید در دسترس نیست',
    request_receipt: 'درخواست رسید',
    fast: 'فوری',
    fee: 'کارمزد',

    /* Module special vocabulary */
    transfers: {
        menu: {
            index: 'سفارش‌ها',
            create: 'سفارش جدید',
            advanced_create: 'ایجاد سفارش پیشرفته',
            advanced_edit: 'ویرایش سفارش',
            list: 'سفارش‌ها',
            "send-money": 'ربیت',
            history: "رهگیری",
            matchmaking: 'هماهنگی',
            ift: 'IFT',
        },
        table_titles: {
            id: 'شناسه',
            user: 'کاربر',
            assignee: 'مسئول',
            incoming_details: 'جزئیات ورودی',
            outgoing_details: 'جزئیات خروجی',
            recipient_name : 'گیرنده',
            recipient_account : 'جزئیات گیرنده',
            recipient_account_type : 'نوع حساب گیرنده',
            recipient_account_number : 'شماره حساب گیرنده',
            reason : 'دلیل',
            sent_amount : 'شما ارسال کردید',
            received_amount : 'آنها دریافت کردند',
            reference : 'مرجع',
            incoming_account: 'حساب ورودی',
            rate : 'نرخ',
            notify: 'اطلاع‌رسانی',
            status : 'وضعیت',
            type : 'نوع',
            ift_date : 'تاریخ IFT',
            note : 'یادداشت',
            notes : 'یادداشت‌ها',
            rebit_account: 'حساب Rebit',
            service_fee: 'کارمزد',
            risk_score: 'امتیاز ریسک',
            referral_earnings: 'پاداش‌ها',
            reward_fee: 'پاداش/کارمزد',
            user_bank_account: 'شماره حساب کاربر',
            registered_at : 'زمان ثبت',
            updated_at : 'تاریخ/زمان به‌روزرسانی',
            setting: 'تنظیمات',
        },
        withdrawal_table_titles: {
            id: 'شناسه',
            amount: 'مبلغ',
            transfer_reference: 'مرجع انتقال',
            from_currency: 'از ارز',
            to_currency: 'به ارز',
            outstanding_amount: 'مبلغ معوق',
            order_payments: 'پرداخت‌های سفارش',
            pre_assigned_code: 'کد از پیش تخصیص‌یافته',
            reference: 'مرجع',
            sent_payment_to_country: 'ارسال پرداخت به کشور',
            bank_name: 'نام بانک',
            to_account_number: 'به شماره حساب',
            swift_bic: 'سوئیفت BIC',
            bank_account_name: 'نام حساب بانکی',
            bank_owner_address_1: 'آدرس صاحب حساب بانک 1',
            bank_owner_address_2: 'آدرس صاحب حساب بانک 2',
            bank_owner_address_country: 'کشور آدرس صاحب حساب بانک',
        },
        ift_table_titles: {
            reference: "مرجع",
            customer: "مشتری",
            customer_email: "ایمیل مشتری",
            gender: "جنسیت",
            date_of_birth: "تاریخ تولد",
            id_document: "مدرک شناسایی",
            status_updated_at: "انتقال یافته در",
            actions: 'اقدامات'
        },
        payment_details_table: {
            date: 'تاریخ/زمان (UTC)',
            amount: 'مبلغ',
            method: 'روش',
            status: 'وضعیت',
        },
        matchmaking: {
            incoming_orders: 'ورودی‌ها',
            outgoing_orders: 'خروجی‌ها',
            transfer_reference: 'مرجع',
            details: 'جزئیات',
            amount: 'مبالغ',
            order_payments: 'پرداخت‌های سفارش',
            transaction_amount: 'مبلغ تراکنش',
            incoming_payment_method: 'روش پرداخت ورودی',
            outgoing_payment_method: 'روش پرداخت خروجی',
        },
        send_money_steps: {
            user: 'کاربر',
            amount: 'مبلغ',
            recipient: 'گیرنده',
            review: 'بازبینی',
            continue: 'ادامه',
            guaranteed_rate: 'نرخ تضمین شده',
            no_user_found: 'کاربری یافت نشد!',
            recipient_s_details: 'مشخصات گیرنده',
            who_are_you_sending_money_to: 'قصد انتقال وجه به چه کسی را دارید؟',
            select_your_recipient: 'گیرنده را مشخص کنید',
            reason_for_transfer: 'علت ارسال وجه',
            pay_quickly_to_avoid_rate_fluctuations: 'برای جلوگیری از نوسانات نرخ، {total_amount} را سریعاً پرداخت کنید.',
            you_send: 'مبلغ ارسالی شما',
            service_fee: 'کارمزد خدمات',
            rewards_discount: 'تخفیف',
            total_to_pay: 'مجموع پرداختی شما',
            recipient_gets: 'مبلغ دریافتی {recipient}',
            recipient_gets_title: 'مبلغ دریافتی گیرنده',
            transfer_time: 'زمان انتقال',
            we_ll_deposit_your_origin_amount_as_soon_as_we_confirm_receipt_of_your_dest_amount: 'به محض اینکه {origin_amount} شما را دریافت کنیم، {dest_currency} را واریز خواهیم کرد.',
            the_transfer_time_window_is_target_only_and_it_s_subject_to_the_availability_of_the_bank_networks_and_local_operators: 'زمان انتقال تقریبی و منوط به در دسترس بودن شبکه‌های بانکی و اپراتورهای محلی است.',
            send_payment_receipts: 'ارسال رسیدهای پرداخت',
            please_upload_payment_receipt_for_this_order: 'لطفاً رسید پرداخت این سفارش را بارگذاری کنید.',
            we_ll_update_your_order_status_shortly: 'به زودی وضعیت سفارش شما را به‌روزرسانی می‌کنیم.',
            file_already_uploaded: 'پیش از این {number_of_files} فایل بارگذاری شده است.',
            files_already_uploaded: 'پیش از این {number_of_files} فایل بارگذاری شده است.',
            payment_receipts: 'رسیدهای پرداخت',
            change: 'ویرایش',
            exchange_rate_expired: 'نرخ قدیمی',
            seems_your_data_is_out_of_date_let_s_try_again: 'اطلاعات نرخ مبادله به روز نیست. لطفاً دوباره تلاش کنید.',
            start_over: 'شروع دوباره',
            duplicate_order: 'سفارش مجدد',
            an_order_already_exist_for_this_recipient: 'برای این گیرنده، از قبل یک سفارش ثبت شده است. لطفاً سفارش قبلی را کامل کنید، یا با پشتیبانی تماس بگیرید.',
            view_existing_oder: 'نمایش لیست سفارش‌ها',
            inactive_currency: 'مسیر غیرفعال',
            demand_for_this_route_is_currently_high_and_we_re_unable_to_accept_more_orders: 'حجم درخواست برای مسیر انتخابی بالا است و در حال حاضر از پذیرش سفارشات جدید معذوریم.',
            please_try_later: 'لطفاً در روزهای آتی مجدداً تلاش کنید.',
            before_we_continue: 'پیش از اینکه ادامه دهیم',
            we_need_to_collect_a_few_more_details: 'ما به اطلاعات مختصر دیگری نیاز داریم.',
            complete_verification: 'تکمیل احراز هویت',
            bank_account: 'حساب بانکی',
            edit_amounts: 'تغییر مبالغ',
            change_recipient: 'تغییر گیرنده',
            payable: 'قابل پرداخت'
        },
        tracking: {
            all_you_paid: 'مجموع پرداختی ما',
            all_we_paid: 'مجموع پرداختی شما',
            details: 'جزئیات',
            timeline: 'زمان‌بندی',
            we_paid: 'پرداختی ما',
            you_paid: 'پرداختی شما',
            pay_now: 'پرداخت',
            send_receipts: 'ارسال رسید',
            cancel_order: 'لغو سفارش',
            edit_recipient: 'ویرایش گیرنده',
            rate_us: 'امتیاز دهید',
            upload_payment_receipts_here_when_needed: 'رسیدهای پرداخت را در صورت نیاز اینجا ارسال کنید.',
            statuses: {
                created: 'ایجاد سفارش',
                awaiting: 'در انتظار تأیید',
                ready_to_pay: 'آماده پرداخت {currency}',
                processing_payment: 'پردازش پرداخت {currency}',
                payment_issue: 'مشکل در پرداخت ({currency})',
                paid: '{currency} پرداخت شده',
                transfer_issue: 'مشکل در انتقال ({currency})',
                transferred: 'انجام شد',
                canceled: 'لغو سفارش',
            },
            timeline_statuses: {
                canceled: 'سفارش شما لغو شده است.',
                transferred: 'تکمیل سفارش',
                payment_issue: 'خطا در پرداخت',
                transfer_issue: 'مشکل در انتقال',
                you_paid: 'پرداخت شما',
                there_was_an_issue_with_your_payment: 'در پرداخت شما مشکلی وجود داشت. لطفاً ایمیتان را برای جزئیات چک کنید.<br> ممکن است این امر در انجام سفارشتان تأخیر ایجاد کند. ',
                please_contact_us_if_your_transfer_is_urgent: 'اگر سفارش شما فوری است، لطفاً {contact_us}',
                contact_us: 'با ما تماس بگیرید.',
                for_poli_payment: 'برای پرداخت‌های POLi، ممکن است وجه شما دیرتر برسد، اما ما در حال پردازش پرداخت به گیرنده شما هستیم.',
                we_have_received_your_order: 'ما سفارش شما را دریافت کرده‌ایم.',
                we_ll_notify_you_once_order_is_ready_to_pay: 'به محض اینکه سفارشتان برای پرداخت {currency} آماده شد، به شما اطلاع می‌دهیم.',
                your_payment_will_be_confirmed_in_the_next_cycle: 'پرداخت شما در سیکل بعدی تأیید می‌گردد',
                you_ll_complete_the_payment_and_upload_receipts: 'شما سفارش را پرداخت و رسید آن را ارسال می‌کنید.',
                we_ll_approve_your_payment: 'ما پرداخت {currency} شما را تأیید خواهیم کرد.',
                we_have_paid_amount_to_recipient_name: 'ما مبلغ {received_amount} به {recipient_name} پرداخت کردیم.',
                order_is_ready_to_pay_currency: 'سفارش شما آماده پرداخت {currency} است.',
                complete_the_payment_and_upload_receipts: 'پرداختتان را به طور کامل انجام داده و رسید آن را بارگذاری کنید.',
                you_ve_uploaded_some_receipts: 'شما رسیدهایی را ارسال کرده‌اید.',
                we_re_approving_your_currency_payment: 'در حال تأیید پرداخت‌های {currency} شما هستیم.',
                converting_your_sent_amount_now: 'در حال تبدیل {sent_amount} شما هستیم.',
                your_total_amount_payment_is_confirmed: 'پرداخت {total_amount} شما تأیید شد. سپاسگزاریم!',
                we_will_be_paying_received_amount_to_recipient_name_s_account_shortly: 'به زودی {received_amount} را به حساب {recipient_name} پرداخت خواهیم کرد.',
                please_check_your_email_and_follow_the_instructions: 'لطفاً اقدامات لازم را از طریق ایمیل دنبال کنید.',
                estimated_settlement_time: 'تخمین زمان تسویه: {transfer_time}',
                anti_money_laundering: 'شما باید پرداختتان را از حساب بانکی {sender_name} انجام دهید.',
                depending_on_local_banks_networks: 'بسته به شبکه بانکی محلی، {recipient_name} به زودی مبلغ را دریافت می‌کند.',
            },
            loading_label: 'در حال دریافت تاریخچه سفارشات...',
            processing: 'در انتظار پردازش',
            accepted: 'تأیید شد',
            cancelled: 'لغو شد',
            if_your_transfer_is_urgent_you_can_send_us_a_screenshot_of_your_payment: 'اگر برای انتقال عجله دارید، می‌توانید اسکرین‌شات پرداخت خود را برای ما ارسال کنید و ما با تمام تلاش سعی می‌کنیم آن را سریعتر انجام دهیم. ',
            although_we_process_orders_every_day_sending_us_your_payment_screenshot: 'اگر چه ما هر روز سفارشات را پردازش می کنیم، ارسال اسکرین شات پرداخت شما، به خصوص در تعطیلات آخر هفته، می‌تواند برای ما مفید باشد.',
            you_can_use_chat_icon_to_do_so: "شما می‌تواند از آیکون چت {icon} استفاده کنید.",
            open_chat: 'چت را باز کن',
            sweet: 'چه خوب',
            too_late_to_cancel: 'درخواست لغو پس از برنامه‌ریزی واریز!',
            we_have_already_set_up_a_payment_plan_for_this_order: 'تراکنش‌های واریز در مبدأ یا مقصد برنامه‌ریزی شده و امکان لغو مستقیم وجود ندارد.',
            if_you_need_to_cancel_this_order_please_get_in_touch_with_support_immediately: "لطفاً در اسرع وقت با پشتیبانی تماس بگیرید.",
            help_and_support: 'پشتیبانی',
            cancel_transfer_order: 'لغو سفارش',
            dismiss: 'بازگشت',
            we_will_stop_processing_your_order: 'پردازش سفارش شما متوقف می‌شود. اما مبلغ این سفارش همچنان از سقف ماهانه شما کسر می‌گردد.',
            recipient_gets: 'دریافتی {recipient}',
            tracking_code_copied: 'کد رهگیری کپی شد!',
            download_receipt: 'دانلود رسید {number}',
        },
        third_party_payments: {
            accepted_payment: 'پرداخت موفق',
            pending_payment: 'پرداخت در انتظار تأیید',
            bank_name: 'نام بانک',
            account_number_do_not_save: 'شماره حساب <span class="text-negative inline-block">ذخیره نکنید</span>',
            account_number_copied: 'شماره حساب کپی شد!',
            recipient_s_name_copied: 'نام گیرنده کپی شد!',
            account_name: 'نام صاحب حساب',
            amount_toman: 'مبلغ (تومان)',
            toman: 'تومان',
            rial: 'ریال',
            amount_copied: 'مبلغ کپی شد!',
            amount: 'مبلغ',
            outstanding: 'باقی‌مانده بدهی',
            remaining_payments_will_show_up_here: 'برای مشاهده باقی‌مانده واریزها مجدداً به این صفحه بازگردید.',
            please_visit_again: '',
            leave_blank: 'خالی بگذارید'
        },
        total_accepted_payments: 'مجموع پرداخت‌های تأیید شده',
        outstanding_amount: 'مانده',
        copy_txid: 'کپی TXID',
        recipient_bank: 'بانک',
        recipient_account_number: 'شماره حساب',
        fees: 'کارمزد',
        "on-ramp": 'رمپ ورودی',
        "off-ramp": 'رمپ خروجی',
        origin_amount: 'مبلغ ارسالی مبدأ',
        dest_amount: 'مبلغ دریافتی مقصد',
        service_fee: 'کارمزد خدمات',
        referral_earnings: 'کل پاداش',
        target_buy_rate: 'نرخ خرید هدف',
        target_sell_rate: 'نرخ فروش هدف',
        on_ramp_margin: 'حاشیه ورودی رمپ',
        off_ramp_margin: 'حاشیه خروجی رمپ',
        order_reference: 'کد رهگیری',
        rate: 'نرخ',
        rewards: 'تخفیف‌',
        total_to_pay: 'مجموع پرداختی',
        gets: 'دریافت می‌کند',
        payment_method: 'روش پرداخت',
        user: 'کاربر',
        edit: 'ویرایش انتقال',
        you_sent: 'مبلغ ارسالی',
        cm_withdrawals: 'لیست برداشت‌ها',
        cm_transactions: 'دریافت تراکنش‌ها',
        withdraw: 'برداشت',
        history: "تاریخچه سفارشات",
        report_to_police: "NZ IFT",
        you_already_have_an_open_order: 'شما هنوز یک سفارش ناتمام دارید!',
        pay_for_existing_order: 'پرداخت سفارش موجود',
        create_a_new_order: 'ایجاد سفارش جدید',
        order_limit: 'سقف سفارش',
        increase_limits: 'افزایش سقف سفارش',
        verify_source_of_funds_to_increase_your_limits: 'منبع وجوه را تأیید کنید تا محدودیت های خود را افزایش دهید',
        send_additional_documents: 'ارسال مدارک تکمیلی',
        our_bank_account: 'حساب بانکی ما',
        thanks_for_your_patience_while_we_assign_a_bank_account_to_your_order: 'شماره حساب واریزی به زودی برای شما تعیین خواهد شد. لطفاً تا دریافت ایمیل بعدی شکیبا باشید!',
        you_can_close_this_page: 'هم‌اکنون می‌توانید از این صفحه خارج شوید.',
        your_order_is_queued_now: 'سفارش شما با موفقیت در صف پردازش قرار گرفت.',
        please_do_not_make_any_deposits_to_previous_bank_accounts: "از واریز به حساب‌های پیشین خودداری کنید.",
        once_admins_confirm_the_account_number_we_ll_notify_you_to_revisit_this_page: 'پس از تعیین شماره حساب می‌توانید این صفحه را بازبینی کنید.',
        payment_details: 'جزئیات پرداخت',
        please_deposit_the_amount_into_the_following_account: "لطفا مبالغ را به حساب‌های زیر واریز نمایید.",
        avoid_bank_references_like: 'از عباراتی چون {rebit}، {iran}، {transfer} و غیره به عنوان رفرنس بانک خودداری کنید.',
        avoid_paying_from_ASB: 'از حساب {ASB} پرداختی انجام ندهید.',
        transfer: 'Transfer',
        iran: 'Iran',
        rebit: 'Rebit',
        upload_a_receipt_for_each_transaction: 'رسید هر واریز را جداگانه بارگذاری کنید.',
        copy_all_details: 'کپی کردن اطلاعات',
        all_details_copied: 'اطلاعات پرداخت کپی شد!',
        send_receipt: 'ارسال رسید',
        track_this_order: 'رهگیری این سفارش',
        rebit_more_money: 'سفارش جدید',
        processing: 'زمان پردازش',
        if_you_can_t_pay_immediately_please_find_the_pay: 'اگر نمی‌توانید پرداختتان را هم‌اکنون انجام دهید، لینک پرداخت را در صفحه رهگیری پیدا کنید.',
        pay_by_method: 'از طریق {method} پرداخت کنید',
        transaction_fee: 'کارمزد این روش',
        back_to_payment_options: 'بازگشت به روش‌های پرداخت',
        delay_warning: 'هشدار تأخیر در واریز',
        nzd_deposits_at_this_time: 'واریزهای NZD در این روزها (جمعه/شنبه/یکشنبه NZST)، دوشنبه آینده انجام می‌شود.',
        select_another_method: 'انتخاب روش دیگر پرداخت',
        please_upload_receipt_for_each_transaction_separately: 'لطفاً به ازای هر تراکنش، یک رسید مجزا ارسال کنید.',
        send_payment_receipt_for: 'ارسال رسید پرداخت مختص مبلغ',
        invalid_order: 'سفارش نامعتبر',
        we_couldnt_find_the_transfer_order_you_re_looking_for: 'هوممم… ما نتوانستیم سفارش انتقال مورد نظرتان را پیدا کنیم.',
        show_my_transfers: 'سفارش‌های مرا نمایش بده',
        monday_is_ok: 'دوشنبه خوب است',
        select_payment_method: 'روش پرداخت را انتخاب کنید',
        i_paid_n: '{n} را پرداخت کردم',
        pay_n_now: 'پرداخت {n}',
        submit_your_first_order: 'اولین سفارشتان را ثبت کنید',
        filtered: 'فیلتر شده',
        bank_details: 'جزئیات بانک',
        we_need_to_complete_your_verification_before_receiving_orders: 'قبل از سفارش لازم است که عملیات احراز هویت را تکمیل کنید.',
        bypass_transfer_amount_limit: 'سقف انتقال را در نظر نگیر',
        no_user_found: 'کاربری یافت نشد',
        select_your_recipient: 'گیرنده ارز را انتخاب کنید',
        add_a_new_recipient: 'افزودن گیرنده جدید',
        complete_verification: 'تکمیل احراز هویت',
        recipient_s_details : 'مشخصات گیرنده',
        who_are_you_sending_money_to: 'گیرنده وجه چه کسی است؟',
        edit_recipient: 'ویرایش گیرنده',
        reason_for_transfer: 'دلیل انتقال وجه',
        gift_or_support_family_friends: 'هدیه یا کمک به خانواده/دوستان',
        travel_holiday_immigration: 'سفر/مهاجرت/تعطیلات',
        real_estate_relocation_rent: 'خرید و فروش مسکن/جابجایی/اجاره',
        university_tuition_fees: 'پرداخت شهریه',
        pay_salary: 'پرداخت حقوق',
        transfer_business_funds: 'انتقال وجوه کسب و کار',
        charity: 'خیریه',
        other: 'سایر موارد',
        type_your_reason_here: 'دلیلتان را اینجا بنویسید',
        review_and_confirm: 'بازبینی و تأیید',
        example_please_pay_by_sunday: 'مثال: لطفاً قبل از یکشنبه تسویه شود.',
        submit_pay_now: 'ثبت و پرداخت',
        if_account_owner_name_is_not: 'چنانچه نام صاحب حساب واریزکننده ریال {first_name} {last_name} نیست لطفاً آن را اینجا وارد کنید.',
        unavailable_receipt_message: 'اگر برای این تراکنش نیاز به رسید دارید، ما تمام تلاش خود را می‌کنیم تا برای شما یک رسید استخراج کنیم.',
        total_on_ramp_amounts: 'مجموع مبالغ آن-رمپ',
        total_off_ramp_amounts: 'مجموع مبالغ آف-رمپ',
        hide_cancelled_orders: 'مخفی کردن سفارشات لغو شده',
        payment_received_thank_you: 'رسید دریافت شد. سپاسگزاریم!',
        overpayment: 'اضافه پرداخت',
        select_your_bank_account: 'حساب بانکی خود را انتخاب کنید',
        which_bank_do_you_pay_from: 'از چه بانکی پرداخت می‌کنید؟',
        add_a_new_bank_account: 'یک حساب بانکی اضافه کنید'
    }
}
